module.exports = {"VendorAddressId":"_","EntityLegalName":"Entity Legal Name","*Name":{"label":"Funding Entity Name","width":300},"Address":"Address","Address2":{"label":"Address 2","visible":false},"City":"City","StateAndRegion":{"label":"State/Region","visible":false},"Zip":"Postal/ZIP Code","Country":"Country","VatNo":"VAT ID","Email":{"label":"Email","visible":false},"EIN":"EIN"}


//////////////////
// WEBPACK FOOTER
// ./src/components/_modules/FundingInvoiceAndAPSettings/FundingAddresses/model.json
// module id = i+Nj
// module chunks = 12